interface InternalTitleProps {
  title: string;
}

export default function InternalTitle({ title }: InternalTitleProps) {
  return <h1 className="text-2xl font-medium text-mglGray900 tablet:text-4xl">{title}</h1>;
}
